// extracted by mini-css-extract-plugin
module.exports = {"textInput":"style-module__textInput___2MT3R"};